<su-headline h="h1" skin="primary">{{config.title | translate}}</su-headline>

<div class="row-chips">
  <su-chip [items]="chips" (onRemove)="handleOnRemoveChip($event)"></su-chip>
</div>

<ng-template #toolbarTpl>
  <su-slot-controls
    mainTLabel="Filter"
    [buttons]="controlButtons"
    [dialogData]="dialogData"
    [modal]="modalComponent"
  ></su-slot-controls>
</ng-template>

<mtx-grid
  [columns]="columns"
  [columnResizable]="config.grid.columnResizable"
  [data]="filteredData"
  [length]="filteredData.length"
  [pageOnFront]="config.grid.paging.pageOnFront"
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="config.grid.paging.pageSize"
  [pageIndex]="config.grid.paging.pageIndex"
  (page)="changePage($event)"
  [sortOnFront]="false"
  (sortChange)="sortChange($event)"
  [loading]="isLoading"
  [rowStriped]="true"
  [noResultText]="'table.no_results' | translate"
  (rowClick)="rowClick.emit($event)"
  (refresh)="refreshData.emit($event)"
  [rowHover]="true"
  [cellSelectable]="false"
  [showPaginator]="config.grid.paging.showPaginator"
  [showColumnMenuButton]="config.grid.showColumnMenu"
  [columnMenuButtonText]="'table.columns_shown' | translate"
  [columnMenuHeaderText]="'table.columnMenuHeaderText' | translate"
  columnMenuButtonClass="col-button"
  columnMenuButtonType="filled"
  [columnHideable]="true"
  [columnHideableChecked]="'show'"
  [columnPinnable]="false"
  [columnSortable]="true"
  [showToolbar]="config.grid.showToolbar"
  [showSidebar]="true"
  [rowSelectable]="config.grid.select.rowSelectable"
  [multiSelectable]="config.grid.select.multiSelectable"
  (rowSelectionChange)="rowSelectionChange.emit($event)"
  [hideRowSelectionCheckbox]="false"
  [toolbarTemplate]="toolbarTpl"
  (columnChange)="saveColumnVisibility()"
>
</mtx-grid>
